export default __webpack_public_path__ + "static/media/basketball.171bb41d.png";